































































































import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { Base } from '@/components/common/base';
import { expenseService, storeService} from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    AppGrid: () => import('@/components/common/app.grid.vue'),
    Calendar: () => import('@/components/common/app.calendar.vue'),
  },
})
class ExpenseGlAccountsReportReportPage extends Base {
  public resetFilter: boolean = false;
  public userName: string = '';
  public vendorNumber: string = '';
  public invoiceNumber: string = '';
  public stores: any[] = [];
  public managers: any[] = [];
  public chargeAccounts: any[] = [];

  public searched: boolean = false;
  public searchParameters: any = {
    selectedManagers: [],
    selectedStores: '',
    approvalStatus: 'All',
    invoiceFromDate: '',
    invoiceToDate: '',
    postingFromDate: '',
    postingToDate: '',
    decisionFromDate: '',
    decisionToDate: '',
    accounts: [],
  };
  public panel: any = 0;
  public pagination = new PaginationModel('expenseId');

  public actions: any[] = [];
  public pagedExpense: any[] = [];
  public headers: VHeaders[] = [
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.subGirdHeaders.ReqApprovalNo'
      ) as string,
      value: 'expenseId',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.subGirdHeaders.storeName'
      ) as string,
      value: 'storeName',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.subGirdHeaders.approvalStatus'
      ) as string,
      value: 'approvalStatus',
    },
    {
      align: 'left',
      text: this.$parent.$t('expenseReports.subGirdHeaders.journal') as string,
      value: 'journal',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.subGirdHeaders.vendorName'
      ) as string,
      value: 'vendorJson.name',
    },
    {
      align: 'left',
      text: this.$parent.$t('expenseReports.subGirdHeaders.vendorNo') as string,
      value: 'vendorJson.vendorId',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.subGirdHeaders.customerName'
      ) as string,
      value: 'customerJson.name',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.subGirdHeaders.customerNo'
      ) as string,
      value: 'customerJson.customerNumber',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.subGirdHeaders.invoiceNo'
      ) as string,
      value: 'invoiceNumber',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.subGirdHeaders.invoiceDate'
      ) as string,
      value: 'invoiceDate',
      fieldType: 'date',
      format: 'L',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.subGirdHeaders.invoiceAmount'
      ) as string,
      value: 'amount',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.subGirdHeaders.PostingAccNo'
      ) as string,
      value: 'payableAccountNumber',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.subGirdHeaders.postingDate'
      ) as string,
      value: 'postingDate',
      fieldType: 'date',
      format: 'L',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: this.$parent.$t('expenseReports.subGirdHeaders.action') as string,
      sortable: false,
    },
  ];
  public storeHeaders: VHeaders[] = [
    {
      align: 'left',
      isNotDataProp: true,
      text: '',
      value: '',
      sortable: false,
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.storeGridHeaders.storeName'
      ) as string,
      value: 'storeName',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.storeGridHeaders.approvedAmount'
      ) as string,
      value: 'approvedAmount',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.storeGridHeaders.pendingAmount'
      ) as string,
      value: 'pendingAmount',
    },
  ];
  public managerHeaders: VHeaders[] = [
    {
      align: 'left',
      isNotDataProp: true,
      text: '',
      value: '',
      sortable: false,
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.managerGridHeaders.accountNumber'
      ) as string,
      value: 'accountNumber',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.managerGridHeaders.approvedAmount'
      ) as string,
      value: 'approvedAmount',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'expenseReports.managerGridHeaders.pendingAmount'
      ) as string,
      value: 'pendingAmount',
    },
  ];

  public flags: any = {
    loading: false,
  };
  public storeLoading: boolean = false;
  public accountLoading: boolean = false;

  public expenseFilters: any[] = [
    'All',
    'Pending',
    'Drafted',
    'Approved',
    'Rejected',
  ];
  public resetFilters() {
    this.searchParameters.postingFromDate = '';
    this.searchParameters.postingToDate = '';
    this.searchParameters.invoiceFromDate = '';
    this.searchParameters.invoiceToDate = '';
    this.searchParameters.decisionFromDate = '';
    this.searchParameters.decisionToDate = '';
    this.searchParameters.accounts = [];
    this.resetFilter = !this.resetFilter;
  }
  public setActions() {
    this.actions = [
      {
        type: 'link',
        icon: 'fas fa-eye',
        title: this.$parent.$t(
          'expenseReports.subGirdHeaders.gridAction.view'
        ) as string,
        disable: (model) => {
          return false;
        },
        action: (model) => {
          return {
            name: 'app.expenses.edit',
            params: {
              expenseId: encodeURIComponent(model.expenseId),
              mode: 'view',
            },
          };
        },
      },
    ];
  }

  public setError(fieldName, errorMsg) {
    this.$validator.errors.add({ field: fieldName, msg: errorMsg });
  }
  public removeError(fieldName) {
    this.$validator.errors.remove(fieldName);
  }

  public async getChargeAccounts(value): Promise<void> {
    this.setError('Account Number', 'Loading Accounts.....');
    this.searchParameters.accounts = [];
    try {
      this.accountLoading = true;
      const chargeAccounts = await expenseService.getStoreChargeAccountsAsync(
        value
      );
      this.removeError('Account Number');
      this.chargeAccounts = chargeAccounts.results;
    } catch (e) {
      this.setError('Account Number', 'Accounts not found');
      this.chargeAccounts = [];
    } finally {
      this.accountLoading = false;
    }
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
  }

  public async getSpendAmountExpenseReports(): Promise<void> {
    if (!(await this.validateForm())) {
      return;
    }

    if (
      !this.searchParameters.invoiceFromDate &&
      !this.searchParameters.invoiceToDate &&
      !this.searchParameters.decisionFromDate &&
      !this.searchParameters.decisionToDate &&
      !this.searchParameters.postingFromDate &&
      !this.searchParameters.postingToDate
    ) {
      this.showAlert(
        false,
        this.$t('expenseReports.alertPleaseSelectOneFilter')
      );
    } else {
      try {
        this.flags.loading = true;
        this.$emit('update:progress', this.flags.loading);
        // tslint:disable-next-line:max-line-length
        const reports = await expenseService.getGlAccountReportsAsync(
          this.pagination,
          this.searchParameters
        );
        this.pagedExpense = reports.results;
        this.pagination.totalItems = reports.total;
      } finally {
        this.flags.loading = false;
        this.$emit('update:progress', this.flags.loading);
      }
    }
  }

  public getStoreManagers(storeDetails) {
    return storeDetails.accounts;
  }

  public resetInvoiceDateRange() {
    this.searchParameters.invoiceToDate = '';
    this.searchParameters.invoiceFromDate = '';
  }
  public resetPostingDateRange() {
    this.searchParameters.postingToDate = '';
    this.searchParameters.postingFromDate = '';
  }
  public resetDecisionDateRange() {
    this.searchParameters.decisionFromDate = '';
    this.searchParameters.decisionToDate = '';
  }
  public getManagerExpenses(managers) {
    managers.expenseDetails.forEach((entry) => {
      if (entry.vendorJson === undefined) {
        entry['vendorJson'] = {
          vendorId: this.$parent.$t('common.NA') as string,
          name: this.$parent.$t('common.NA') as string,
        };
      }
      if (entry.customerJson === undefined) {
        entry['customerJson'] = {
          customerNumber: this.$parent.$t('common.NA') as string,
          name: this.$parent.$t('common.NA') as string,
        };
      }
    });
    return managers.expenseDetails;
  }
  public getSum(lineItems) {
    return '0.00';
  }

  public async getStores(): Promise<void> {
    try {
      this.storeLoading = true;
      const stores = await storeService.getUserStoresList();
      this.stores = stores.results;
    } catch (e) {
      this.stores = [];
    } finally {
      this.storeLoading = false;
    }
  }
  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }

  public callMethod(methodName): void {
    if (methodName === 'getSpendAmountExpenseReports') {
      this.getSpendAmountExpenseReports();
    }
    if (methodName === 'resetFilters') {
      this.resetFilters();
    }
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    // let buttons: any = [];
    // buttons.push({'id':'0', 'type':'button', 'title':'Filter Data', 'disabled':false, 'visible': true, 'class':'btn', 'label':'Filter Data', 'click':'getSpendAmountExpenseReports', 'icon':'fas fa-filter','requestProgress': true});
    // buttons.push({'id':'1', 'type':'button', 'title':'Reset', 'disabled':false, 'visible': true, 'class':'btn', 'label':'Reset', 'click':'resetFilters', 'icon':'fas fa-redo','requestProgress': true});
    // this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'expenseGlAccounts');

    // toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.vendorNumber = (this.$route.query.vendorNumber as string) || '';
    const approvalStatus = this.$route.query.approvalStatus || '';
    if (approvalStatus) {
      this.searchParameters.approvalStatus = approvalStatus;
    }
    this.getStores();
    this.searchParameters.selectedStores = '' + this.userSession.storeId;
    if (this.searchParameters.selectedStores) {
      this.getChargeAccounts(this.searchParameters.selectedStores);
    }
    this.setActions();
  }

  public setInvoiceDateParmsGlAccount(dates: any) {
    if (dates.length > 1) {
      this.searchParameters.invoiceFromDate = dates[0];
      this.searchParameters.invoiceToDate = dates[1];
    }
  }

  public setPostingDateParms(dates: any) {
    if (dates.length > 1) {
      this.searchParameters.postingFromDate = dates[0];
      this.searchParameters.postingToDate = dates[1];
    }
  }
  public setdecisionDateParmsGlAccount(dates: any) {
    if (dates.length > 1) {
      this.searchParameters.decisionFromDate = dates[0];
      this.searchParameters.decisionToDate = dates[1];
    }
  }
}
export default ExpenseGlAccountsReportReportPage;
